import { transparentize } from 'polished';
import { css } from 'styled-components';

import { themeTokens as checkoutThemeTokens } from '../../../checkout/styles/themes/yitty/themeTokens';
import { desktop, mobile } from '../../../techstyle-shared/react-components';

import { sizes } from './sizes';

export const themeTokens = {
  accountConfirmation: {
    backgroundOpacity: '100%',
    backgroundUrl: ``,
    backgroundSize: 'auto',
    header: css`
      color: ${({ theme: { colors } }) => colors.textConfirmation};
      font-family: ${({ theme: { fontStacks } }) =>
        fontStacks.condensedTradeGothicFamily};
      text-transform: uppercase;
    `,
    subheader: css`
      color: ${({ theme: { colors } }) => colors.textConfirmation};
      margin-top: ${({ theme: { sizes } }) => sizes.sm}px;
      font-size: 20px;
      font-weight: 600;
      font-style: italic;
      text-align: center;
    `,
  },
  activatingMembershipLogo: css`
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      height: auto;
      width: 98px;
      fill: ${({ theme }) => theme.colors.palette.white};
    }
  `,
  backgroundConfirmationOpacity: '100%',
  backgroundConfirmationUrl: `url('/static/LogoScroll.png')`,
  borderRadius: `${sizes.xs}px`,
  borderRadiusCard: `${sizes.sm}px`,
  borderRadiusCart: `${sizes.sm}px`,
  borderRadiusForm: `${sizes.sm}px`,
  borderRadiusInput: `${sizes.xxs}px`,
  borderRadiusInset: `${sizes.xs}px`,
  borderRadiusRound: '999999999px',
  borderRadiusTextArea: `${sizes.sm}px`,
  borderRadiusModal: '10px',
  displayTextTab: css`
    span {
      font-weight: 700;
      font-size: 40px;
      line-height: 50px;
      ${mobile`
        font-size: 32px;
        line-height: 40px;
      `}
      color: ${({ theme }) => theme.colors.palette.black};
      border-bottom: 4px solid transparent;
      &:hover {
        border-color: ${({ theme }) => theme.colors.palette.black};
      }
    }
    border: unset;
    border-radius: unset;
    padding: 6px 24px;
    ${mobile`
      padding: 4px 20px;
    `}
  `,
  displayTextTabSelected: css`
    span {
      font-weight: 700;
      font-size: 40px;
      line-height: 50px;
      ${mobile`
        font-size: 32px;
        line-height: 40px;
      `}
      color: ${({ theme }) => theme.colors.alertRed};
      border-bottom: 4px solid ${({ theme }) => theme.colors.alertRed};
    }
    border: unset;
    border-radius: unset;
    padding: 6px 24px;
    ${mobile`
      padding: 4px 20px;
    `}
  `,
  quizSizingBorderRadius: '16px',
  defaultLayout: {
    body: css`
      min-height: 50vh;
      position: relative;
      isolation: isolate;
    `,
  },
  formInputFields: css`
    border: 3px solid ${({ theme }) => theme.colors.borderLight};
    border-radius: ${({ theme }) => theme.sizes.sm}px;
    width: 100%;

    & > div:first-of-type fieldset {
      border-top-right-radius: ${({ theme }) => theme.sizes.xs}px;
      border-top-left-radius: ${({ theme }) => theme.sizes.xs}px;
    }

    & > div:last-of-type fieldset {
      border-bottom-right-radius: ${({ theme }) => theme.sizes.xs}px;
      border-bottom-left-radius: ${({ theme }) => theme.sizes.xs}px;
    }
  `,
  heroNodeMemberBox: css`
    margin-top: -32px;
  `,
  miniCartOverflowBoxShadow: '0px 0px 20px -5px rgba(0, 0, 0, 0.1)',
  memberBox: {
    sectionWrapper: css``,
    wrapper: css`
      background: ${({ theme }) => theme.colors.white};
      border-top-left-radius: ${({ theme }) => theme.sizes.sm}px;
      border-top-right-radius: ${({ theme }) => theme.sizes.sm}px;
      z-index: 2;
      position: relative;
      border-bottom: 1px solid
        ${({ theme: { colors } }) => colors.memberBoxBorder};

      ${desktop`
        display: flex;
        height: 55px;
        align-items: center;
      `}
      ${mobile`
        width: 100%;
      `}
    `,
    cta: {
      text: css`
        font-weight: 700;
        color: ${({ theme }) => theme.colors.white};
      `,
      wrapper: css`
        border-width: 1px;
      `,
    },
    tidbit: {
      label: css`
        font-weight: 600;
        font-size: 10px;
        text-transform: uppercase;
      `,
      value: css`
        font-size: 12px;
      `,
    },
  },
  fullWidthCarousel: css`
    background: ${({ theme }) => theme.colors.palette.black};
  `,
  carouselButtonAccessibilityStyles: css`
    &:focus {
      box-shadow: 0 0 0 5px #19f;
    }
    @supports not (selector(:focus-visible)) {
      &:focus {
        box-shadow: 0 0 0 5px #19f;
      }
    }

    &:focus-visible {
      box-shadow: 0 0 0 5px #19f;
    }
  `,
  memberInfo: {
    nonVipDisplay: {
      wrapper: css`
        background: ${({ theme: { colors } }) =>
          colors.palette.lightestSoftSilk};

        ${desktop`
          padding: 8px 6px 8px 16px;
        `}
      `,
      title: css`
        font-size: 14px;
        font-weight: 500;

        ${mobile`
          margin-bottom: 5px;
        `}

        ${desktop`
          margin-bottom: 3px;
        `}
      `,
      descriptiveCopy: css`
        ${desktop`
          font-weight: 400;
        `}
      `,
      styledButton: css`
        ${mobile`
          background: ${({ theme: { colors } }) =>
            colors.palette.lightestSoftSilk};

          span {
            font-weight: 500;
            color: ${({ theme: { colors } }) => colors.palette.black};
          }
        `}

        ${desktop`
          padding: 6px 14px;
        `}
      `,
    },
    trialMembershipDisplay: {
      greeting: css`
        ${mobile`
          font-size: 14px;
        `}
      `,
      title: css`
        font-weight: 600;

        ${desktop`
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 5px;
        `}
      `,
      descriptiveCopy: css`
        font-weight: 400;
      `,
      styledButton: css`
        ${mobile`
          border-radius: 12px;
          span {
            font-weight: 700;
          }
        `}
        ${desktop`
          padding: 6px 9px;
        `}
      `,
    },
    vipMembershipDisplay: {
      wrapper: css``,
      greeting: css`
        ${mobile`
          font-size: 16px;
        `}
      `,
      mobileContentSpacerStyle: css`
        ${mobile`
          margin: 7px 0 0 0;
        `}
      `,
    },
    balanceWrapper: css`
      font-size: 14px;
      font-weight: 400;

      span {
        font-weight: 700;
      }

      ${desktop`
        font-size: 12px;
      `}
    `,
    membershipCreditsWithIconWrapper: css``,
  },
  profileSectionBorderRadius: '16px',
  accountShipping: {
    modalContentBorderRadius: css`
      ${mobile`
        border-radius: 10px 10px 0 0;
      `}
    `,
    buttonResize: css`
      width: calc(50% - ${({ theme }) => theme.space('xs', true)});
      margin: 0;
      ${mobile`
        width: calc(100% - 48px);
        margin: 0 24px;
      `}
    `,
    addressModalButtonResize: css``,
  },
  backToTopButton: css`
    color: ${({ theme }) => theme.colors.textLight};
    background-color: ${({ theme }) =>
      transparentize(0.05, theme.colors.sublabelBlack)};
    ${desktop`
    background-color: ${({ theme }) =>
      transparentize(0.05, theme.colors.palette.black)};
  `}
  `,
  profileGreetingBox: {
    borderBottom: css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.palette.lightGray2};
      width: 50%;
      margin: 0 auto;
      ${mobile`
        width: 100%;
      `}
    `,
    memberSince: {
      text: css`
        color: ${({ theme }) => theme.colors.textDeemphasized};
      `,
      startDate: css`
        color: ${({ theme }) => theme.colors.textDefault};
      `,
    },
  },
  pdpStyles: {
    productOverlay: {
      productNameTitle: css``,
    },
    swatchSelector: {
      noOptionsWrapper: css`
        font-family: ${({ theme }) => theme.fonts.primary};
        font-size: 14px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.palette.eerieBlack50};
        border: 1px solid ${({ theme }) => theme.colors.palette.eerieBlack25};
        border-radius: 4px;
        padding: 7px 16px;
      `,
      swatchLabelOOSMessage: css`
        color: ${({ theme }) => theme.colors.palette.errorRed};
        font-weight: 600;
      `,
    },
    promoMessage: {
      gshopPriceText: css``,
      gshopMsrpMemberPriceText: css``,
      wrapper: css`
        background-color: ${({ theme }) => theme.colors.palette.mamba25};
        padding: 6px 8px 6px 8px;
        display: inline-block;
      `,
      copy: css`
        color: ${({ theme }) => theme.colors.palette.eerieBlack};
        font-weight: 700;
        font-size: 14px;
      `,
      strikethroughCopy: css`
        font-weight: 700;
        font-size: 14px;
      `,
      priceOfferOr: css`
        font-size: 14px;
      `,
    },
    wishlist: {
      ctaWrapper: css`
        border: 1px solid ${({ theme }) => theme.colors.unfocusedSublabel};
        border-radius: 4px;
        padding: 12px 22px;
      `,
      wishListLabel: css`
        color: ${({ theme }) => theme.colors.focusText};
        font-weight: 700;
        font-size: 14px;
      `,
    },
    detailsSection: {
      accordionLabel: css`
        font-size: 16px;
        color: ${({ theme }) => theme.colors.sublabelBlack};
      `,
    },
    fitGuarantee: {
      header: css`
        text-transform: uppercase;
        font-size: 18px;
        font-weight: 700;
      `,
      copy: css`
        color: ${({ theme }) => theme.colors.darkGray};
      `,
    },
    quantitySelectors: {
      indicator: {
        label: css`
          font-weight: 400;
        `,
        value: css`
          font-weight: 700;
          color: ${({ theme }) => theme.colors.palette.lightBlack};
        `,
      },
      baseButton: css``,
      currentQuantityStyle: css`
        font-weight: 500;
      `,
    },
    afterpayStyles: css`
      afterpay-placement {
        ${({ theme }) => theme.typography.values.paragraph1}
        --logo-badge-width: 85px;
        color: ${({ theme }) => theme.colors.palette.lighterBlack};
        margin: 10px 0 0 0;
      }
    `,
    ctaWrapper: css`
      ${mobile`
        padding: 0 25px;
      `}
    `,
    vipCtaWrapper: css`
      display: flex;
      flex-direction: column;
      padding: 16px;
      background: ${({ theme }) => theme.colors.palette.paleSilver50};
      border: 1px solid ${({ theme }) => theme.colors.palette.eerieBlack25};
      border-radius: 2px;
    `,
    vipAddToBagButton: css`
      margin: 12px 0;
      color: ${({ theme }) => theme.colors.textLight};
    `,
    vipOptIn: {
      promoMessageWrapper: css``,
      vipOptInMessageWrapper: css`
        font-size: 12px;
        line-height: 1.3;
        margin: 8px 0 20px 0;
        color: ${({ theme }) => theme.colors.textDefault};
      `,
      modalLink: css`
        color: ${({ theme }) => theme.colors.learnMoreLink};
        font-size: inherit;
        text-decoration: underline;

        display: block;
      `,
    },
    vipAddToBag: {
      button: css``,
      label: {
        promoPrice: css`
          font-weight: 600;
          font-size: 18px;
          color: ${({ theme }) => theme.colors.palette.white};
        `,
      },
    },
    empAddToBag: {
      button: css`
        ${({ disabled }) =>
          disabled &&
          css`
            cursor: not-allowed;
            background: ${({ theme }) => theme.colors.palette.shadow20};
            border: none;
            color: ${({ theme }) => theme.colors.palette.shadow40};

            &:hover,
            &:focus,
            &:active {
              background: ${({ theme }) => theme.colors.palette.shadow20};
            }
          `}
      `,
    },
    guestAddToBag: {
      label: css``,
      button: css`
        margin-top: 16px;
      `,
      productPrice: {
        priceStyle: css`
          font-weight: 700;
        `,
      },
    },
    guestCtaWrapper: css`
      font-weight: 600;
      padding: 16px 0;
    `,
    priceWrapper: css`
      ${mobile`
      padding: 16px 0 8px 24px;
      `};
    `,
    productNameMargin: css`
      margin-top: 24px;
    `,
    upsellPromos: css`
      color: ${({ theme }) => theme.colors.textEmphasized};
      font-weight: 700;
    `,
    upsellCarousel: {
      carouselHeading: css`
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: ${({ theme }) => theme.sizes.m};
        letter-spacing: 0.0025em;
        color: ${({ theme }) => theme.colors.trueBlack};
        padding-bottom: 0;

        text-align: center;
      `,
      content: css`
        display: grid;
        grid-template-areas: 'image carousel carousel carousel';
        grid-template-columns: repeat(4, 1fr);

        ${mobile`
          display: flex;
          flex-direction: column;
          max-height: unset;
          gap: 16px;
        `}
      `,
      fullWidthCarousel: css`
        margin-bottom: 0;
      `,
      productsWrapper: css`
        grid-area: carousel;

        ${mobile`
          grid-area: grid;
          display: grid;
          grid-gap: ${({ theme }) => theme.spacing.sizes.pixels.s}px;
          margin: 0 ${({ theme }) => theme.spacing.sizes.pixels.s}px;
          grid-template-columns: repeat(2, 1fr);
        `}
      `,
      imageWrapper: css`
        grid-area: image;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        padding-top: 20px;
      `,
      carouselCellStyles: css`
        margin-right: ${({ theme }) => theme.spacing.sizes.pixels.s}px;
        width: 165px;
      `,
      imageCaption: css`
        font-family: ${({ theme }) => theme.fontStacks.baseFamily};
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: ${({ theme }) => theme.sizes.m};
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.midnight};
        margin-bottom: ${({ theme }) => theme.spacing.sizes.pixels.xxs}px;
      `,
      mobileCaption: css`
        font-family: ${({ theme }) => theme.fontStacks.baseFamily};
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 1.28;
        text-align: center;
        letter-spacing: 0.02em;
        color: ${({ theme }) => theme.colors.trueBlack};
        margin-bottom: ${({ theme }) => theme.spacing.sizes.pixels.xxs}px;
      `,
    },
    mobileHeaderStyle: css`
      display: block;
    `,
    mobileHeaderTitle: css`
      & > h1 span {
        font-size: 18px;
      }
    `,
    mobileHeaderCallout: css`
      font-size: 12px;
    `,
    enhancedMemberModel: {
      button: {
        base: css`
          height: 32px;
          padding: 4px 22px;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
          border-radius: 8px;
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;
          gap: 12px;
        `,
        chevron: css`
          width: 14px;
          height: 8px;
          color: ${({ theme }) => theme.colors.palette.trueBlack};
          transform: rotate(
            ${({ $direction }) => ($direction === 'UP' ? 180 : 0)}deg
          );
        `,
        labelWrapper: css`
          color: ${({ theme }) => theme.colors.palette.trueBlack};
          font-weight: 600;
          font-size: 14px;
          text-transform: uppercase;
          line-height: calc(24 / 16);
        `,
        wrapper: css`
          cursor: pointer;
          position: absolute;
          top: 11px;
          left: 8px;
          z-index: 1;

          ${mobile`
            bottom: 32px;
            left: 30%;
            top: unset;
         `}
        `,
      },
      content: {
        dropdown: {
          base: css`
            position: relative;
            width: 100%;
          `,
          list: css`
            top: 40px;
            position: absolute;
          `,
        },
        wrapper: css`
          position: relative;
          max-height: 650px;
          width: 428px;
          overflow-y: auto;
          scroll-behvaior: smooth;
          z-index: 3;
          border-radius: 8px;
          box-shadow: 0px 2px 8px rgba(8, 90, 103, 0.08),
            0px 8px 16px rgba(0, 0, 0, 0.08);
          background-color: ${({ theme }) => theme.colors.white};

          ${mobile`
            width: 100%;
            max-height: unset;
          `}
        `,
        selectionLabel: {
          wrapper: css`
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            width: 100%;
            height: 42px;
            position: sticky;
            top: 0;

            background: ${({ theme }) => theme.colors.palette.white};
            border-bottom: 1px solid
              ${({ theme }) => theme.colors.palette.lightGray};
          `,
          label: css`
            font-weight: 600;
            font-size: 16px;
            line-height: calc(18 / 14);
            text-transform: uppercase;
            ${mobile`
              font-size: 14px;
            `}
          `,
        },
        modal: {
          wrapper: css`
            top: auto;
          `,
          dialog: css`
            @media (max-width: ${({ theme }) =>
                theme.breakpoints.tablet.maxWidth}px) {
              width: 100%;
              height: 60vh;
            }
          `,
        },
      },
      item: {
        wrapper: css`
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: row;

          padding: 24px 37px 16px 51px;
          gap: 12px;

          border-bottom: 1px solid
            ${({ theme }) => theme.colors.palette.lightGray};
          background: ${({ $isActive, theme }) =>
            theme.colors.palette[$isActive ? 'lightestSoftSilk' : 'white']};

          ${mobile`
            padding: 16px 37px 16px 29px;
          `}
        `,
        dimensions: css`
          display: grid;
          margin-top: 8px;
          grid-template-columns: repeat(2, minmax(100px, 1fr));
          grid-template-rows: repeat(2, 1fr);
          grid-gap: 4px 18px;
          font-size: 14px;
          font-weight: 400;
          b {
            font-weight: 700;
          }
          ${mobile`
            margin-top: 12px;
          `}
        `,
        imageWrapper: css`
          picture,
          picture img {
            height: 100%;
            width: 100%;
          }
          && {
            width: 75px;
            height: 112px;
          }
          box-sizing: content-box;
          border: ${({ $isActive, theme }) =>
            $isActive && `2px solid ${theme.colors.palette.eerieBlack}`};
          margin-bottom: 0;
        `,
        heightLabel: css`
          display: flex;
          flex-direction: row;
          font-weight: 400;
          font-size: 16px;
          b {
            font-weight: 700;
          }
          ${mobile`
            font-size: 14px;
          `}
        `,
        info: {
          wrapper: css`
            display: flex;
            flex-direction: column;
            gap: 2px;
          `,
          nameLabel: css`
            display: flex;
            flex-direction: row;
            gap: 8px;
          `,
          activeIcon: css`
            color: ${({ theme }) => theme.colors.mamba};
            font-size: 16px;
          `,
        },
      },
      indicatorWrapper: css`
        width: 100%;
        height: 18px;
        text-align: center;
        display: flex;
        justify-content: center;
        padding-top: 12px;
        font-size: 14px;
        font-weight: 600;

        ${mobile`
          margin-bottom: 12px;
        `}
      `,
    },
  },
  selectorStyles: {
    itemSoldOutStyle: css`
      background: ${({ theme }) => theme.colors.palette.shadow15};
      border-width: 2px;
      &:before {
        background: none;
      }
    `,
    itemSizeLabelStyle: css`
      ${({ theme }) => theme.typography.values.paragraph2};
      font-weight: 600;
      text-align: center;
      position: absolute;
      right: 0;
      left: 0;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.palette.black};
      ${({ isSoldOut, isChecked }) =>
        isSoldOut &&
        css`
          opacity: 60%;
        `}

      ${({ isSoldOut, isChecked }) =>
        isSoldOut &&
        isChecked &&
        css`
          color: ${({ theme }) => theme.colors.palette.black};
        `}
    `,
    inputSizeStyle: css`
      font-weight: 600;
      border-radius: 4px;
      border: 1px solid ${({ theme }) => theme.colors.palette.shadow25};
      background: ${({ theme }) => theme.colors.palette.white};
      margin: 0px;
      width: 100%;
      height: 40px;

      input:checked + && {
        font-weight: 700;
        border: 2px solid ${({ theme }) => theme.colors.sublabelBlack};
        background: ${({ theme }) => theme.colors.palette.white};
      }

      input:focus + && {
        outline: none;
        box-shadow: unset;
      }

      ${({ isSoldOut }) =>
        isSoldOut &&
        css`
          &:before {
            background: linear-gradient(
              to right bottom,
              ${({ theme }) => theme.colors.palette.shadow15},
              ${({ theme }) => theme.colors.palette.shadow15} 48%,
              ${({ theme }) => theme.colors.unfocusedSublabel} 49%,
              ${({ theme }) => theme.colors.unfocusedSublabel} 51%,
              ${({ theme }) => theme.colors.palette.shadow15} 52%,
              ${({ theme }) => theme.colors.palette.shadow15}
            );
          }
          input:checked + && {
            &:before {
              background: linear-gradient(
                to right bottom,
                ${({ theme }) => theme.colors.palette.shadow15},
                ${({ theme }) => theme.colors.palette.shadow15} 48%,
                ${({ theme }) => theme.colors.palette.shadow80},
                ${({ theme }) => theme.colors.palette.shadow80},
                ${({ theme }) => theme.colors.palette.shadow15} 52%,
                ${({ theme }) => theme.colors.palette.shadow15}
              );
            }
            border: 2px solid ${({ theme }) => theme.colors.palette.shadow80};
          }
        `}
    `,
    selectedLabelTextStyle: css`
      color: ${({ theme }) => theme.colors.textDefault};
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
    `,
    selectSizeWarningLabel: css`
      color: ${({ theme }) => theme.colors.textDeemphasized};
      line-height: 1.14;
      letter-spacing: ${-0.25 / 14}em;
      font-weight: 600;
    `,
    selectSizeWarningMessage: css`
      color: ${({ theme }) => theme.colors.errorMessage};
      line-height: 1.14;
      letter-spacing: ${-0.25 / 14}em;
      text-transform: none;
      font-weight: 600;
    `,
    selectorLabelStyle: css`
      ${({ theme }) => theme.typography.values.paragraph1};
      color: ${({ theme }) => theme.colors.sublabelBlack};
      font-weight: 400;
      text-transform: capitalize;
    `,
    selectorTextWrapper: css`
      color: ${({ theme }) => theme.colors.sublabelBlack};
      font-size: 14px;
      font-weight: 600;

      margin-top: 8px;
    `,
    selectedOptionSizeLabelWrapper: css``,
    selectorCategoryWrapperStyle: css``,
    productDetailLabelsWrapper: css`
      margin: 6px 0;
    `,
    braSizeAttributeSelectorWrapper: css``,
    selectOptionLabelWrapper: css`
      padding-top: 3px;
      margin: 6px 0;
    `,
    sizeSummaryWrapper: css``,
    fitSelectorValue: css`
      font-weight: 700;
      color: ${({ theme }) => theme.colors.palette.black};
    `,
    sizeGuideMargin: '0 auto',
  },
  reviewSummaryStyleOverrides: {
    cellStyle: css`
      border: 1px solid ${({ theme }) => theme.colors.palette.shadow15};
      box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.colors.palette.shadow15},
        inset 0 1px 0 0 ${({ theme }) => theme.colors.palette.shadow15},
        inset 1px 0 0 0 ${({ theme }) => theme.colors.palette.shadow15},
        inset -1px 0 0 0 ${({ theme }) => theme.colors.palette.shadow15};
    `,
    recommendPercentageStyle: css`
      ${mobile`
        ${({ theme }) => theme.typography.values.paragraph1};
        color: ${({ theme }) => theme.colors.textEmphasized};
        margin-top: 16px;
      `}
    `,
    percentageValueStyle: css`
      font-weight: bold;
    `,
    fitTypeStyle: css`
      ${desktop`
        font-size: 14px;
      `}
    `,
    overallFitStyle: css`
      ${desktop`
        font-size: 16px;
        font-weight: 800;
      `}
    `,
    reviewTitleStyle: css`
      font-size: 20px !important;
      text-transform: uppercase;
    `,
  },
  reviewsSummaryWrapper: css`
    background-color: ${({ theme }) => theme.colors.palette.shadow10};
    box-shadow: inset 0 1px 0 0 ${({ theme }) => theme.colors.palette.shadow15};
    margin: 32px auto 0;
    padding: 48px 0 32px;
    ${mobile`
      margin: 0 auto;
      background-color: ${({ theme }) => theme.colors.palette.white};
    `}
  `,
  moreReviewsButton: css`
    ${({ theme }) => theme.typography.values.paragraph1};
    width: 343px;
    max-width: 95%;
    border-radius: 4px;
    height: 48px;
    margin: 32px 0 32px 0;
    align-self: center;
    text-transform: uppercase;

    ${({ theme }) => css`
      background-color: ${theme.colors.sublabelBlack};
      border: 1px solid ${theme.colors.sublabelBlack};
    `};

    ${mobile`
      margin: 16px 0 16px 0;
    `}
  `,
  recentReviewsStyle: {
    blockStyle: css`
      &:first-of-type {
        border-radius: 3px 3px 0 0;
      }
      &:last-of-type {
        border-radius: 0 0 3px 3px;
      }
    `,
    productInfoStyle: css`
      text-transform: uppercase;
      font-weight: 400;
      span {
        color: ${({ theme }) => theme.colors.sublabelBlack};
        &:last-child {
          font-weight: 700;
        }
      }
    `,
    reviewStarsStyle: css`
      color: ${({ theme }) => theme.colors.iconColor};
    `,
    dateStyle: css`
      span {
        color: ${({ theme }) => theme.colors.palette.lighterBlack};
        ${desktop`
          color: ${({ theme }) => theme.colors.sublabelBlack};
        `}
      }
    `,
    contentStyle: css`
      color: ${({ theme }) => theme.colors.sublabelBlack};
      ${desktop`
        color: ${({ theme }) => theme.colors.textDefault};
      `}
    `,
  },
  reviewsFiltersStyles: {
    applyButtonStyle: css`
      width: 100%;
      font-weight: 700;
      ${({ theme }) => theme.typography.values.paragraph2};
    `,
    clearAllButtonStyle: css`
      span {
        color: ${({ theme }) => theme.colors.textDefault};
      }
    `,
    filterAndSortButton: css`
      font-size: 16px;
      font-weight: 600;
      font-style: normal;
      text-transform: uppercase;
      line-height: 1.5;
      border: 0;
      margin: 0;
      padding: 0;
      background: transparent;
      color: inherit;
      display: flex;
      align-items: center;
      height: 24px;
      font-family: ${({ theme }) => theme.fontStacks.baseFamily};
    `,
  },
  overallRatingStyles: {
    barFillStyle: css`
      // fix fill overflow
      max-width: 100%;
      background-color: ${({ theme, $isActive }) =>
        $isActive
          ? theme.colors.selectedFilterColor
          : theme.colors.sublabelBlack};
    `,
    barStyle: css`
      background-color: ${({ theme }) => theme.colors.palette.gray};
    `,
    ratingCountStyle: css`
      color: ${({ theme }) => theme.colors.textDefault};
      letter-spacing: -0.35px;
    `,
    ratingNumberStyle: css`
      color: ${({ theme }) => theme.colors.sublabelBlack};
    `,
    starIconStyle: css`
      color: ${({ theme, $isActive }) =>
        $isActive ? theme.colors.selectedFilterColor : theme.colors.iconColor};
    `,
  },
  headNavLogo: css`
    max-width: ${({ width }) => width || '52px'};
    width: 100%;

    ${mobile`
      max-width: 65px;
  `}
  `,
  anniversaryLogo: css``,
  favorites: {
    gridWrapper: css`
      border: 1px solid ${({ theme }) => theme.colors.palette.gray};
      border-radius: ${({ theme }) => `${theme.sizes.sm}px`};
    `,
    addToCartCta: css`
      & > span {
        font-weight: 600;
      }
    `,
  },
  reviewsModal: {
    header: {
      count: css`
        font-size: 14px;
        ${desktop`
          text-decoration: underline;
        `}
      `,
      text: css`
        font-size: 14px;
        ${desktop`
          font-size: 16px;
        `}
      `,
    },
  },
  reviewStyles: {
    baseketItemStyle: css``,
    radioBarContainerStyle: `
      column-gap: 8px;
    `,
    radioBarStyle: css`
      height: 16px;
      border-radius: ${({ theme }) => theme.borderRadius};
    `,
    radioLabelStyle: css`
      ${({ theme }) => theme.typography.values.paragraph1};
      font-weight: 600;

      ${({ isSelected }) =>
        isSelected &&
        css`
          color: ${({ theme }) => theme.colors.textEmphasized};
        `}
    `,
    ctaButtonStyle: css`
      flex: 0 0 30%;

      ${mobile`
        flex-basis: 100%;
      `}
    `,
    ctaButtonContainerStyle: css`
      justify-content: center;

      ${mobile`
        flex-direction: column;
        gap: ${({ theme }) => theme.sizes.sm}px;
      `}
    `,
  },
  account: {
    accountPageMobileMenuDropDownButton: css``,
    accountPageMobileMenuWrapper: css``,
    pageBodyStyle: css`
      width: 100%;
      margin: 0 auto;

      ${desktop`
          flex: 1;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: flex-start;
          align-content: flex-start;
          max-width: 868px;
          display: grid;
          gap: 12px;
          grid-template-columns: auto 1fr;
          padding-top: 58px;
          padding-bottom: 40px;
        `};
    `,
    pageHeadingSize: '22px',
    pageTitle: css``,
    styledLinkText: css``,
    myVipStyles: {
      vipPerksMainContent: css``,
      bannerBackground: css`
        background: ${({ theme }) => theme.colors.backgroundCallout};
      `,
      rewardSummaryStyle: `
        border-radius: 16.5px;
      `,
      contactChatStyle: css`
        color: ${({ theme }) => theme.colors.palette.lighterBlack};
      `,
      itemContentTextStyle: css`
        font-size: 16px;
        color: ${({ theme }) => theme.colors.textDeemphasized};
      `,
      itemContentTextEmphasizedStyle: css`
        color: ${({ theme }) => theme.colors.textEmphasized};
        font-weight: 700;
      `,
      startChatButtonStyle: css`
        padding: ${({ theme }) => `${theme.sizes.xs}px ${theme.sizes.xxl}px`};
        ${({ theme }) => theme.typography.values.paragraph1}
      `,

      vipTreatment: {
        mainContainer: css`
          padding-bottom: ${({ theme }) => theme.spacing.sizes.pixels.xxs}px;
          border-bottom: 1px solid ${({ theme }) => theme.colors.palette.gray};
          font-family: ${({ theme }) => theme.fontStacks.baseFamily};
          text-transform: capitalize;
          width: 235px;
          cursor: pointer;
          display: flex;
          ${mobile`
            width: 100%;
            padding: 15px 25px;
          `}
        `,
        sections: css`
          padding: ${({ theme }) => theme.spacing.sizes.pixels.xxs}px;
          border-bottom: 1px solid ${({ theme }) => theme.colors.palette.gray};
          font-family: ${({ theme }) => theme.fontStacks.baseFamily};
          display: flex;
          ${mobile`
          margin: 0 15px;
          `}
        `,
        subTitle: css`
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          ${mobile`
            text-decoration: underline;
          `}
        `,
        title: css`
          font-weight: 700;
          font-size: 14px;
        `,
        sectionTitle: css`
          font-weight: 600;
          font-size: 16px;
          text-transform: uppercase;
          margin-bottom: 5px;
        `,
        sectionDescription: css`
          font-size: 12px;
          font-weight: 400;
        `,
        learnMoreButton: css`
          span {
            font-weight: 600;
            font-size: 14px;
          }
          border-radius: 16px;
          margin: 12px 30px;
          padding: 14px 40px;
          height: 48px;
          min-width: 160px;
          ${mobile`
            margin: 12px 25px;
            background-color: #fff;
            border: 3px solid ${({ theme }) => theme.colors.palette.black};
            height: 68px;
            min-width: 311px;
            span {
              color: ${({ theme }) => theme.colors.palette.black};
            }
          }
          `}
        `,
      },
    },
    myVipModalStyles: {
      modalContentBorderRadius: css`
        ${mobile`
          border-radius: 0 0 0 0;
        `}
      `,
      buttonResize: css`
        width: calc(100% - 5px);
        margin: 0 auto;
        height: 45px;
      `,
      OrdersModalButtonResize: css`
        padding: 10px;
        flex: 0 0 max(110px, 25%);
      `,
      modalContentWidth: css`
        width: 60%;
        margin: 0 auto;
        ${mobile`

      `}
      `,
      overlayColor: css`
        overlaycolor: ${({ theme }) => theme.colors.palette.black60};
      `,
      closeButton: css`
        cursor: pointer;
        position: absolute;
        display: flex;
        width: 56px;
        height: 56px;
        align-items: center;
        justify-content: center;
        top: 0;
        right: 0;
        padding: 8px;
        border-width: 0;
        color: ${({ theme }) => theme.colors.palette.darkenGray};
        line-height: 0;
        ${desktop`
        top: 14px;
        right: 14px;
      `}
      `,
    },
  },
  footerStyles: {
    wrapperStyle: css`
      border-top: 3px solid ${({ theme }) => theme.colors.palette.gray};
    `,
    dividerStyle: css`
      width: 100%;
      margin: 50px auto 0;
      border: none;
      border-top: 3px solid ${({ theme }) => theme.colors.palette.gray};
      ${mobile`display:none;`}
    `,
    freeShippingDetailsStyle: css`
      color: ${({ theme }) => theme.colors.palette.mediumGray};
    `,
    sectionMenuLinkStyle: css`
      display: inline-block;
      font-weight: 400;
      ${({ theme }) => theme.typography.values.paragraph1};

      ${({ $isLinkHeader }) =>
        $isLinkHeader &&
        css`
          &:link:hover [data-nav-item-label] {
            text-decoration: underline;
          }
        `}

      ${desktop`
        &:link:hover [data-nav-item-label] {
          text-decoration: underline;
        }
      `}

      ${mobile`
        font-weight: 600;
        ${({ theme }) => theme.typography.values.caption};
        :link {
          display: flex;
          align-items: center;
        }
      `}
    `,
    adaWidgetButtonCopy: css`
      padding: 0;
      & > * {
        font-weight: inherit;
      }

      ${({ $isBuilderFooterLink }) =>
        $isBuilderFooterLink &&
        css`
          color: ${({ theme }) => theme.colors.palette.lightBlack};
        `}

      ${desktop`
        &:hover,
        &:focus {
          text-decoration: underline;
        },
      `}

      ${mobile`
        text-transform: uppercase;
      `}
    `,
    sectionStyle: css`
      &:first-child {
        margin-top: 0;
      }

      ${mobile`
        border-bottom: 1px solid ${({ theme }) =>
          transparentize(0.6, theme.colors.palette.white)};
      `};
    `,
    sectionTitleStyle: css`
      text-transform: uppercase;
      margin: 0;
      padding: 6px 0 ${({ theme }) => theme.sizes.sm}px;
      ${({ theme }) => theme.typography.values.caption};
      font-weight: 700;

      ${mobile`
        font-weight: 600;
        padding-top: 1.25em;
        padding-bottom: 1.25em;
      `}

      &&& > * {
        ${({ theme }) => theme.typography.values.caption}
        font-weight: inherit;
        font-size: 14px;
      }
    `,
    socialIconWrapperStyle: css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.palette.gray};
      padding-top: ${({ theme }) => theme.sizes.md}px;
      padding-bottom: ${({ theme }) => theme.sizes.md}px;
    `,
  },
  gridCellStyles: {
    defaultPriceStyle: css`
      ${({ theme }) => theme.typography.values.heading5};
      color: ${({ theme }) => theme.colors.textDefault};
      font-size: 14px;
      font-weight: normal;
    `,
    priceStyles: css`
      font-size: 14px;
      font-weight: 600;

      color: ${({ theme }) => theme.colors.palette.shadow40};
    `,
    vipPriceStyles: css`
      font-size: 14px;
      font-weight: 600;

      color: ${({ theme }) => theme.colors.sublabelBlack};
    `,
    defaultPromoPriceStyle: css`
      color: ${({ theme }) => theme.colors.textEmphasized};
      font-weight: 600;
      font-size: 14px;
    `,
    moreColorsLink: css`
      ${({ theme }) => theme.typography.values.paragraph1};
      color: ${({ theme }) => theme.colors.palette.mediumGray};
      margin-top: 4px;
      font-weight: 600;
    `,
    priceContent: css`
      line-height: 1.4;
      font-size: 14px;
    `,
    productCellWrapper: css`
      font-size: 14px;
      position: relative;
      text-align: left;
      min-width: 100%;
    `,
    productName: css`
      display: block;
      ${({ theme }) => theme.typography.values.paragraph2};
      color: ${({ theme }) => theme.colors.sublabelBlack};
      font-weight: 500;
      line-height: 1.4;
      font-size: 14px;
      margin-bottom: 6px;
    `,
    promoMessage: css`
      ${({ theme }) => theme.typography.values.paragraph1};
      hyphens: auto;
      overflow-wrap: break-word;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 6px;
      display: inline-block;
      color: ${({ theme }) => theme.colors.palette.wenge};
    `,
    gridColorSwatchWrapper: css`
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 3px;
    `,
    gridSwatchInputStyle: css`
      width: 26px;
      height: 26px;
    `,
    gridSwatchMoreIconStyle: css`
      width: 22px;
      height: 22px;
      padding-top: 4px;
    `,
    gridSwatchImageActiveStyle: css`
      width: 18px;
      height: 18px;
    `,
    gridSwatchImageDefaultStyle: css`
      width: 22px;
      height: 22px;
    `,
    gridSwatchInputGap: css`
      gap: 1px;
    `,
    calloutText: css`
      color: ${({ theme }) => theme.colors.palette.mamba};
      font-weight: 400;
    `,
    upsellCarousel: {
      productImageWrapper: css`
        margin-bottom: 5px;
      `,
      productName: css`
        margin-bottom: 5px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.sublabelBlack};
      `,
      promoMessage: css`
        font-size: 16px;
      `,
      promoPrice: css`
        color: ${({ theme }) => theme.colors.promoText};
        font-size: 16px;
        font-weight: 600;
      `,
    },
    swatches: {
      swatchLabel: css`
        color: ${({ theme }) => theme.colors.palette.trueBlack};
        font-weight: 400;
        margin: 8px 0px;
      `,
      swatchColorLabel: css`
        font-size: 14px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.palette.trueBlack};
      `,
      swatchWrapper: css``,
    },
  },
  gridFilterStyles: {
    listingFilterStyle: css`
      font-family: ${({ theme }) => theme.fontStacks.navBarFamily};
    `,
    colorFilterStyle: css`
      font-size: 0.875rem; // 14px
      font-weight: 400;
    `,
    filterCategoryTitleStyle: css`
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.palette.black};
    `,
    desktopSortLabelStyle: css``,
    desktopSortButtonStyle: css``,
    sortActiveSelectionStyle: css``,
    nestedHeadingStyle: css`
      font-size: 14px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.palette.lighterBlack};
    `,
    filterFieldLabelStyle: css`
      font-weight: 600;
      color: ${({ theme }) => theme.colors.palette.black};
      font-size: 14px;
      line-height: 1.3;
    `,
    filterCountStyle: css`
      font-size: 14px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.palette.lighterBlack};
    `,
    inputStyle: css`
      border: 3px solid ${({ theme }) => theme.colors.palette.lightestBlack};
      border-radius: 4px;
    `,
    inputCheckedStyle: css`
      border-color: ${({ theme }) => theme.colors.focusText};
      background: ${({ theme }) => theme.colors.focusText};
    `,
    tagStyle: css`
      border-radius: 4px;
      background-color: ${({ theme }) => theme.colors.palette.paleSilver75};
      font-weight: 600;
      color: ${({ theme }) => theme.colors.focusText};
    `,
    deselectIconStyle: css`
      color: ${({ theme }) => theme.colors.palette.eerieBlack50};
    `,
    circleIconStyle: css`
      border: solid 1px ${({ theme }) => theme.colors.palette.trueBlack};
    `,
    noFiltersAppliedStyle: css`
      font-weight: 600;
      color: ${({ theme }) => theme.colors.sublabelBlack};
    `,
    headerStyle: css`
      font-weight: 600;
      line-height: 24px;
      color: ${({ theme }) => theme.colors.sublabelBlack};
    `,
    gridLabelStyle: css`
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      color: ${({ theme }) => theme.colors.palette.black};
    `,
    filterButtonMobileStyle: css`
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      color: ${({ theme }) => theme.colors.palette.black};
    `,
    gridInputStyle: css`
      border-radius: 4px;
      border: 1.5px solid ${({ theme }) => theme.colors.palette.eerieBlack};
    `,
    swatchInputStyle: css`
      background-color: ${({ theme }) => theme.colors.palette.gray};
    `,
    applyFiltersButtonStyle: css`
      background-color: ${({ theme }) => theme.colors.palette.eerieBlack};
      border-radius: 4px;
      min-height: 48px;
      text-transform: uppercase;
    `,
    clearAllButtonStyle: css`
      color: ${({ theme }) => theme.colors.palette.eerieBlack50};
    `,
    filterFieldButtonSvgStyle: css`
      font-size: 20px;
    `,
  },
  gridStyles: {
    breadcrumbItemStyle: css`
      font-weight: ${({ isActive }) => (isActive ? `600` : `400`)};
    `,
    productCalloutOverlayStyle: css``,
    carouselWrapperStyle: css`
      min-height: 580px;
      ${mobile`
            min-height: 445px;
        `}
    `,
    categoryDropdownLinkStyle: css`
      font-size: 16px;
      text-align: center;
      color: ${({ theme }) => theme.colors.textDefault};
      box-shadow: none;
      padding: 19px;
      padding-left: 8px;

      &[data-active-category='true'] {
        border-radius: 4px;
        background-color: #dcf1f4;
        color: inherit;
      }
    `,
    activeDesktopCategoryItemStyle: css``,
    desktopCategoryItemStyle: css``,
    activeCategoryItemStyle: css`
      color: ${({ theme }) => theme.colors.textActionDeemphasized};
      font-weight: 600;
      text-decoration: underline;
    `,
    categoryItemStyle: css`
      ${({ theme }) => theme.typography.values.paragraph1};
      color: ${({ theme }) => theme.colors.palette.lighterBlack};
      font-weight: 400;
      display: block;
      margin-bottom: 16px;
    `,
    categoryTree: css`
      ${({ theme }) => theme.typography.values.paragraph1};
      color: ${({ theme }) => theme.colors.palette.lighterBlack};
      font-weight: 550;
      margin-bottom: 32px;
    `,
    topLevelCategoryHeading: css`
      ${({ theme }) => theme.typography.values.paragraph2};
      color: ${({ theme }) => theme.colors.sublabelBlack};
      font-weight: 600;
      margin-bottom: 13px;
    `,
    gridCtaButtonStyle: css`
      ${({ theme: { colors, sizes } }) => `
        background: ${colors.palette.black};
        color: ${colors.palette.white};
        padding: ${sizes.sm}px 56px;
        border-radius: ${sizes.xxs}px;
      `}

      ${({ theme: { colors, fontStacks, sizes }, $isCarouselGrid }) =>
        $isCarouselGrid &&
        `
          background: ${colors.palette.white};
          color: ${colors.palette.black};
          padding: ${sizes.xxs}px 46px;
          border-radius: ${sizes.xxxs}px;
          border: 1px solid ${colors.palette.black};

          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 16px;
        `}
    `,
    gridCarouselLabelStyle: css`
      text-transform: uppercase;
      font-weight: 800;
      font-size: ${({ theme: { sizes } }) => sizes.lg}px;
      line-height: ${({ theme: { sizes } }) => sizes.xxl}px;
      color: ${({ theme }) => theme.colors.textDefault};

      ${mobile`
        font-style: normal;
        font-size: 24px;
        margin: ${({ theme: { sizes } }) => sizes.sm}px;
        display: block;
      `}
    `,
    gridCarouselViewAllCta: css`
      border: none;
      color: ${({ theme }) => theme.colors.textDefault};
      font-weight: 800;
      font-size: ${({ theme: { sizes } }) => sizes.md}px;
      line-height: 24px;
      text-underline-offset: ${({ theme: { sizes } }) => sizes.xxxs}px;
      text-decoration: underline;
      background: transparent;
    `,
    sortLabel: css`
      font-weight: 600;
    `,
    filterDrawerButton: css`
      font-weight: 600;
    `,
    desktopSortLabelStyle: css`
      font-size: 14px;
    `,
    sortActiveSelectionStyle: css``,
    discoveryGuideAssetCard: css`
      width: 165px;
      height: 310px;

      ${desktop`
        width: 300px;
        height: 480px;
      `}
    `,
    discoveryGuideFilterPill: css`
      font-size: 16px;
      font-weight: 600;
      padding: 8px 16px;
    `,
  },
  gridHeaderStyle: css`
    font-size: 24px;
    font-weight: bold;
    flex-grow: 1;
    ${mobile`
      display: none
    `};
  `,
  mobileGridHeaderStyle: css`
    ${mobile`
      font-size: 24px;
    `}
  `,
  mobileProductListingFilterStyles: {
    gridInput: {
      border: '3px solid #eaeaea',
    },
  },
  billMeNow: {
    BorderRadius: css`
      border-radius: 8px;
    `,
    paymentListRadioStyle: css`
      input:checked + && {
        background: ${({ theme }) => theme.colors.focusText};
        color: ${({ theme }) => theme.colors.textLight};
        border: 0.88px solid ${({ theme }) => theme.colors.focusText};
      }
    `,
    confirmationWrapper: css`
      padding: ${({ theme }) => theme.spacing.sizes.pixels.m}px
        ${({ theme }) => theme.spacing.sizes.pixels.s}px;
      ${mobile`
        padding: 36px 15px;
      `}
    `,
    confirmationPayment: {
      titleBoldness: css`
        font-weight: 600;
      `,
      amntDivPadding: css`
        padding: 11px;
        width: 100%;
        border-radius: 0 16px 16px 0;
      `,
      bmnBtn: css`
        padding: 0;
      `,
    },
    modal: {
      title: css``,
    },
  },
  onlineCancelStyling: {
    ribbonContainer: css`
      background: ${({ theme }) => theme.colors.palette.white};
    `,
    pauseBanner: css`
      background: ${({ theme }) => theme.colors.palette.white};
    `,
    offerCallOut: css`
      background: ${({ theme }) => theme.colors.backgroundCallout};
      color: ${({ theme }) => theme.colors.textLight};
    `,
    offerCta: css`
      text-transform: uppercase;
      font-size: 14px;
      background: ${({ theme }) => theme.colors.palette.white};
      color: ${({ theme }) => theme.colors.textDefault};
      border: none;
      border-radius: 100px;
      padding: 10px 30px;
      font-weight: 600;
      cursor: pointer;

      &:hover {
        filter: brightness(0.9) contrast(1.1);
      }
    `,
    areYouSureHeaderStyling: css`
      padding-top: 12px;
      padding-bottom: 10px;
    `,
    cancelConfirmBtnStyle: css`
      background: ${({ theme }) => theme.colors.palette.black};
      width: 50%;
      font-size: 18px;

      ${({ disabled }) =>
        disabled &&
        css`
          color: ${({ theme }) => theme.colors.palette.shadow40};
          background-color: ${({ theme }) => theme.colors.palette.shadow20};

          &:hover {
            color: ${({ theme }) => theme.colors.palette.shadow40};
            background-color: ${({ theme }) => theme.colors.palette.shadow20};
          }
        `}
    `,
    cancelFinalBtnStyle: css`
      width: 35%;
      margin: 35px auto;
      display: block;
      background: ${({ theme }) => theme.colors.onlineCancelFinalButton};
      color: ${({ theme }) => theme.colors.palette.white};
      padding: 15px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 5px;
      text-align: center;
      ${mobile` width: 100%;`}
    `,
    ctaNeutral: css`
      background: ${({ theme }) => theme.colors.backgroundDark};
      color: ${({ theme }) => theme.colors.backgroundLight};
      font-size: 14px;
    `,
    ctaActive: css`
      background: ${({ theme }) => theme.colors.backgroundDark};
      color: ${({ theme }) => theme.colors.backgroundLight};
      opacity: 1;
      &:hover {
        background: ${({ theme }) => theme.colors.backgroundDark};
        > span {
          color: ${({ theme }) => theme.colors.backgroundLight};
        }
      }
    `,
    ctaDisable: css`
      background: ${({ theme }) => theme.colors.backgroundEmphasizedLight};
      > span {
        color: ${({ theme }) => theme.colors.backgroundLight};
      }
    `,
    ctaDisableHover: css`
      background: ${({ theme }) => theme.colors.backgroundDark};
      > span {
        color: ${({ theme }) => theme.colors.backgroundLight};
      }
    `,
    wrapperActive: css`
      filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.15));
      border: 1px solid ${({ theme }) => theme.colors.backgroundDark};
    `,
    wrapperNeutral: css`
      color: ${({ theme }) => theme.colors.backgroundDark};
    `,
    wrapperDisable: css``,
    borderRadiusSize: css`
      border-radius: 16px;
    `,
    iconDisable: css`
      color: ${({ theme }) => theme.colors.backgroundEmphasizedLight};
    `,
    iconActive: css`
      color: ${({ theme }) => theme.colors.backgroundDark};
    `,
    checkBoxImportant: css`
      background: ${({ theme }) => theme.colors.palette.black} !important;
      color: ${({ theme }) => theme.colors.textLight} !important;
    `,
    stillHaveQuestions: {
      contactButtons: css`
        color: ${({ theme }) => theme.colors.palette.black};
        background-color: ${({ theme }) => theme.colors.palette.white};
        border: 1px solid ${({ theme }) => theme.colors.backgroundLight};

        &:hover {
          background-color: ${({ theme }) => theme.colors.palette.mamba25};
          border: 1px solid
            ${({ theme }) => theme.colors.backgroundEmphasizedLight};
        }
      `,
    },
  },
  activateTrial: {
    submitButton: css``,
  },
  quiz: {
    answers: css`
      ${desktop`
        max-width: 1200px;
      `}
      ${mobile`
        width: 100%;
        max-width: 360px;
        height: auto;
      `}
      @media (max-width: 1240px) {
        width: 600px;
      }
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    `,
    answerButton: css`
      border-radius: 16px;
      ${mobile`
        width: 100%;
        `}
      ${desktop`
        min-width: 250px;
        transform: scale(1);
        &:active {
          transform: scale(0.9);
        }
      `}
    `,
    answerFocused: css``,
    answerButtonWrapper: css`
      border-radius: 16px;
      ${desktop`
        width: 100%;
        max-width: fit-content;
        flex: 0 1 calc( 100% / ${({ $columns }) => $columns} );
        align-self: flex-end;
        margin: 0 ${({ theme }) => theme.sizes.sm}px;
        margin-top: ${({ theme }) => theme.sizes.lg}px;
      `}
      @media (max-width: 1240px) {
        width: 100%;
        flex: 0.75 1 50%;
      }
    `,
    answerTextStyle: css`
      ${mobile`
        padding: 12px 2px;
      `}
    `,
    answerWrapper: css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 16px;
      color: ${({ theme }) => theme.colors.palette.deepBrown};
      ${desktop`
        width: 250px;
        max-height: 386px;
        &:hover,
        &:focus {
          color: ${({ theme }) => theme.colors.quizAnswerColorHover};
          transition: background-color 0.5s ease, color 0.5s ease, scale 0.5s;
        }
      `}
      ${mobile`
        max-height: 241px;
        width: 147px;
        flex-direction: column;
        margin: 12px;
        ${({ $multiline }) =>
          $multiline &&
          css`
            width: 100%;
            flex-direction: row;
            justify-content: flex-start;
          `}
      `}
    `,
    assetWrapper: css`
      overflow: hidden;
      border-radius: 16px;
      // added mask-image bc border radius was not persisting on hover in safari
      ${desktop`
        mask-image: radial-gradient(white, black);
        background-color: ${({ theme }) => theme.colors.palette.white};
        width: 100%;
      `}
    `,
    backButton: css`
      ${mobile`
        font-size: 24px;
      `}
    `,
    closeButton: css``,
    defaultRegistrationFieldsColumn: css`
      & > div {
        display: flex;
        flex-direction: column;
        position: relative;
        column-gap: 10px;
        row-gap: 24px;

        ${mobile`
          row-gap: 8px;
        `}

        > div:last-of-type,
        > div:first-of-type {
          border-radius: ${({ theme }) => theme.borderRadiusInput};
          border: none;
        }

        > div {
          border-radius: ${({ theme }) => theme.borderRadiusInput};
          height: ${({ showZip }) => (showZip ? '48px' : '72px')};

          ${mobile`
            height: ${({ showZip }) => (showZip ? '56px' : '72px')};
          `}

          > fieldset {
            padding: 0;
            ${mobile`
              padding-left: 10px;
            `}

            &:focus-within {
              padding: 0;
            }

            label {
              color: ${({ theme }) => theme.colors.registrationFieldsLabel};
            }
          }

          border: none;

          &.has_error {
            border: 1px solid ${({ theme }) => theme.colors.error} !important;
          }
        }
      }
    `,
    quizDropdownButtonBorder: css`
      border: ${({ theme }) => theme.quiz.quizBorder} solid
        ${({ theme }) => theme.colors.borderLight};
      border-radius: 16px;
      background-color: ${({ theme }) => theme.colors.borderLight};
    `,
    dropdownButtonBorder: css`
      border: ${({ theme }) => theme.quiz.quizBorder} solid
        ${({ theme }) => theme.colors.borderLight};
    `,
    quizSizeBlockMobile: css``,
    selectFieldSetLabel: css`
      ${mobile`
        top: 13px;
        left: 13px;
      `}
    `,
    skipButton: css`
      ${desktop`
        top: 16px;
      `}

      ${mobile`
        top: unset;
        padding-top: 2px;
        padding-bottom: 2px;
      `}
    `,
    navBarWrapper: 'padding: 24px 32px;',
    editButton: css``,
    errorPosition: css`
      margin-top: -25px;
      padding: 30px 6px 8px 6px;
    `,
    /* Main wrapper for the HDYH dropdown */
    HowDidYouHearDropdownWrapper: css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `,
    quizDropdownContentContainer: css`
      ${mobile`
        padding: 0;
      `}
    `,
    TieredQuizDropdownContentWrapper: css`
      padding: 0px 1px;
      ${mobile`
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      `}
      button {
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        ${desktop`
          margin: 1px 0px;
        `}
      }
    `,
    registrationPageDesktop: css``,
    skippedRegistrationPageDesktop: css`
      width: 100%;
      align-items: center;
      justify-content: center;
    `,
    fieldWrapper: css`
      position: relative;

      ${mobile`
        #topSize,
        #bottomSize,
        #braSize,
        #referrer {
          ${({ theme: { colors, borderRadiusInput }, showZip }) => `
            height: ${showZip ? '56px' : '72px'};
            background-color: ${colors.palette.white};
            border-radius: ${borderRadiusInput};
          `}

          :focus {
            border-color: ${({ theme }) => theme.colors.focusColor};
          }

          label {
            padding-left: 8px;
          }

          &:has(option:checked:not([value=""])) ~ label {
            padding: 0;
          }

        }

        #bottomSize.has_error,
        #topSize.has_error,
        #braSize.has_error,
        #referrer.has_error {
          border-color: ${({ theme }) => theme.colors.error};
        }
      `}

      ${desktop`
        #referrer:has(option:checked:not([value=""])) ~ label {
          padding-top: 8px;
        }

        label[for='referrer'] {
          text-align: left;
          padding-top: 0;
        }
      `}
    `,
    builderNoAssetAnswer: css`
      ${({ theme: { typography } }) =>
        typography.variants.quizAnswer.textStyle};
      min-height: fit-content;
      width: fit-content;
      padding: 20px 40px;
      border-radius: 16px;
      ${desktop`
        &:hover,
        &:focus {
            color: ${({ theme }) => theme.colors.textLight};
          }
        }
      `}
      ${mobile`
        margin: ${({ theme }) => theme.sizes.xs}px;
        padding: 20px;
      `}
    `,
    noAssetAnswer: css`
      ${({ theme: { typography } }) =>
        typography.variants.quizAnswer.textStyle};
      min-height: fit-content;
      width: fit-content;
      padding: 20px 40px;
      border-radius: 16px;
      ${desktop`
        &:hover,
        &:focus {
            color: ${({ theme }) => theme.colors.textLight};
          }
        }
      `}
      ${mobile`
        margin: ${({ theme }) => theme.sizes.xs}px;
        padding: 20px;
      `}
    `,
    modalDialog: 'min-width: 610px;',
    sizingPageBottomForm: 'width: 438px;',
    quizBirthdayABTestStyles: {
      formFieldWrapper: css``,
      zipCodeAndBirthdayWrapper: css``,
    },
    panelStyle: css`
      min-height: 600px;
    `,
    multiSelectAnswerButton: css`
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      border-radius: 20px;
      flex-flow: column nowrap;
      width: 247px;
      margin: 12px;
      align-items: center;
      max-height: none;

      picture {
        overflow: hidden;
        border-radius: 20px;
      }

      img {
        transition: scale 0.5s;
      }

      &:hover,
      &:focus {
        background-color: ${({ theme }) => theme.colors.palette.deepBrown};
        color: ${({ theme }) => theme.colors.palette.white};

        img {
          scale: 1.1;
        }
      }

      ${mobile`
        flex-flow: column nowrap;
        width: 147px;
        justify-content: center;
      `}
    `,
    multiSelectAnswerText: css`
      color: ${({ theme }) => theme.colors.palette.white};
    `,
    multiSelectAnswerTextFocused: css`
      color: ${({ theme }) => theme.colors.palette.white};
      background-color: transparent;
    `,
    progressBar: css`
      border: 1px solid ${({ theme }) => theme.colors.palette.deepBrown};
      height: 12px;
      width: 311px;
      border-radius: 16px;
      display: flex;
      justify-content: flex-start;
      ${desktop`
        margin-top: ${({ theme }) => theme.sizes.sm}px;
      `}
      ${mobile`
        margin-top: 20px;
      `}
      span:first-child {
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
      }
      span:only-child {
        border-radius: 16px;
      }
    `,
    barStyle: css`
      height: 100%;
      background: ${({ $filled, theme }) =>
        $filled ? theme.colors.palette.deepBrown : 'transparent'};
      ${({ $lastBar }) =>
        $lastBar &&
        css`
          border-top-right-radius: 16px;
          border-bottom-right-radius: 16px;
        `}
    `,
    questionStyle: css`
      ${({ theme: { typography } }) => typography.values.heading6};
      line-height: 1.25;
      ${mobile`
        padding: 0 12px;
        margin: ${({ theme }) => theme.sizes.sm}px;
      `}
    `,
    questionTitleStyle: css`
      ${({ theme: { typography } }) => typography.values.heading6};
      line-height: 1.25;
      ${mobile`
        padding: 0 12px;
        margin: ${({ theme }) => theme.sizes.sm}px;
      `}
    `,
    questionSubtitle: css``,
    quizBorder: '3px',
    quizTieredDropdownMobileLeftPadding: '22px',
    quizLayoutWrapper: css``,
    quizLayout: css``,
    quizLogoWrapper: css``,
    quizNavLogo: css`
      svg {
        width: 100%;
        height: auto;
        max-width: 52px;

        ${mobile`
          height: 40px;
          max-width: 65px;
        `}
      }
    `,
    quizNextButton: css`
      align-self: center;
      max-width: 158px;
      width: 100%;
      margin-top: 24px;
      ${({ theme: { colors } }) => `
        color: ${colors.palette.white};
        background-color: ${colors.quizButtonBackground};
      `}
    `,
    quizSignUpButton: css``,
    quizPageContainer: css`
      ${desktop`
        min-width: 730px;
        padding: 0px 40px;
      `}
      ${mobile`
        margin-bottom: 32px;
        height: 100%;
        flex-flow: column nowrap;
      `}
    `,
    quizPageRegistrationWrapper: css`
      min-width: unset;
      padding: 0;
      margin: 0;
      ${mobile`
            height: 100%;
            overflow-y: auto;
          `}
      width: 100%;
      display: flex;
      flex-direction: column;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
    `,
    quizSizingRegPadding: css`
      padding: 56px 0px;
      padding-top: 8px;
      ${mobile`
        padding: 56px 16px;
        padding-top: 8px;
      `}
    `,
    quizSizingHeader: css`
      ${mobile`
        padding: ${sizes.md}px;
        padding-top: 0;
      `}
    `,
    quizSizingBlock: css`
      ${({ theme: { sizes, colors }, $selected }) => `
        padding: ${sizes.sm}px;
        border-radius: ${sizes.xxs}px;
        border: 1px solid ${colors.palette.gray};
        ${
          $selected
            ? `border: 3px solid ${colors.palette.deepBrown};`
            : `margin: 2px;`
        };
        :hover {
          border: 1px solid ${colors.palette.deepBrown};
        }
      `}

      background-color: ${({ theme: { colors } }) => colors.demureBorder};
    `,
    quizSizingInnerWrapper: css`
      ${mobile`
        height: 70vh;
      `}
    `,
    quizSizingZipCodeWrapperStyles: css`
      fieldset {
        border-radius: 0;
      }

      :first-child {
        fieldset {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          ${mobile`
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;
          `}
        }
      }

      :not(:first-child) {
        border-radius: 0;
      }
    `,
    quizSizingZipCodeErrorWrapperStyles: css`
      background-color: ${({ theme: { colors } }) => colors.error};
    `,
    quizSizingZipCodeErrorTextStyles: css`
      color: ${({ theme: { colors } }) => colors.palette.white};
    `,
    regButtonMargin: '56px 0',
    regFormFields: css``,
    registrationFormWrapper: css`
      display: flex;
      flex-flow: column nowrap;
      width: 323px;
      ${desktop`
        width: 450px;
      `}
    `,
    registrationForm: '',
    quizSizingReferrerButton: `
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 16px;
      border-bottom-left-radius: 16px;
    `,
    quizLocationReferrerButton: '',
    regPageHeight: '100%',
    registrationPage: css`
      justify-content: center;
    `,
    skippedRegistration: css`
      margin-top: 32px;
      ${mobile`
        margin-top: 0;
      `}
    `,
    skippedRegSelect: css`
      & ~ label {
        color: ${({ theme }) => theme.colors.quizDropdownLabel};
      }

      ${mobile`
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-left: 1px solid;
        border-right: 1px solid;
      `}
    `,
    smSpacer: css`
      height: ${({ theme: { sizes } }) => sizes.sm}px;
    `,
    mdSpacer: css`
      height: ${({ theme: { sizes } }) => sizes.md}px;
    `,
    termsAndPrivacy: css`
      text-align: center;
      a {
        ${({ theme: { typography } }) => typography.values.caption};
        font-weight: 600;
        padding: 0 12px;
      }
      span {
        border-color: ${({ theme }) => theme.colors.linkTextDeemphasized};
      }
    `,
    zipCodeInput: css`
      fieldset {
        height: 100%;
        label[data-label-position='inside'] {
          color: ${({ theme }) => theme.colors.quizDropdownLabel};
        }
      }

      ${desktop`
        ${({ theme: { sizes, colors, quiz } }) => `
          border-top: ${quiz.quizBorder} solid ${colors.palette.gray};
          border-top-left-radius: ${sizes.sm}px;
          border-top-right-radius: ${sizes.sm}px;
        `}
      `}
    `,
  },
  sweepstakeForm: {
    textFieldBorder: '1px',
    regFormFields: css`
      label[data-label-position='inside'] {
        font-size: 12px;
      }

      input {
        font-size: 16px;
      }
    `,
    successPanel: {
      title: css`
        ${({ theme }) => theme.typography.values.heading3};
        font-weight: 700;
        text-align: center;
      `,
      postTitleText: css`
        ${({ theme }) => theme.typography.values.paragraph2};
        font-style: normal;
        font-weight: 400;
        text-align: center;
      `,
    },
  },
  countdownStyles: {
    postreg: {
      text: css`
        font-size: 18px;
      `,
    },
    sweepstake: {
      timer: {
        label: css`
          font-style: normal;
          font-weight: 700;
          font-size: 12px;
          line-height: 1;
        `,
        value: css`
          font-weight: 700;

          font-size: 75px;
          line-height: 1;
          ${mobile`
            font-size: 30px;
          `}
        `,
      },
    },
  },
  marketingCards: {
    variants: {
      default: {
        marketingCardsHeader: css``,
        cardsHeaderTitle: css``,
        cardsContainer: css`
          @media (max-width: 959px) {
            gap: 30px;
            grid-template-columns: repeat(2, 1fr);
          }

          @media (max-width: 767px) {
            grid-template-columns: repeat(1, 1fr);
          }
        `,
        cardVariant: 'VIPHomepage',
      },
      giftGuide: {
        marketingCardsHeader: css`
          height: 50px;
          width: 100%;
          margin: 0;

          ${mobile`
            display: none;
          `}
        `,
        cardsHeaderTitle: css`
          color: ${({ theme: { colors } }) => colors.palette.white};

          ${mobile`
            display: none;
          `}
        `,
        cardsContainer: css`
          grid-template-areas:
            'card_1 card_2'
            'card_3 card_4';

          grid-gap: 20px;
          grid-template-columns: repeat(2, 1fr);
          margin: 0 22px;

          ${desktop`
            grid-template-areas: 'card_1 card_2 card_3 card_4';
            grid-template-columns: repeat(4, 1fr);
            grid-column-gap: 24px;
            grid-row-gap: 0px;
            max-width: 1042px;
          `}
        `,
        cardVariant: 'giftGuide',
      },
    },
  },
  marketingCard: {
    variants: {
      default: {
        card: css``,
        cardTitle: css``,
        cardbody: css`
          min-height: 150px;
          padding: 21px 0 21px 12px;
        `,
        cardSubtitle: css``,
        cardImage: css`
          max-width: 100%;
        `,
      },
      VIPHomepage: {
        card: css`
          overflow: hidden;
          border-radius: 16px;
          box-shadow: 0px 0px 28px -5px rgb(0 0 0 / 15%);
          @media (max-width: 959px) {
            border-radius: 0;
          }
        `,
        cardbody: css`
          min-height: 150px;
          padding: 21px 0 21px 12px;
          min-height: 136px;
          min-width: 200px;
          @media (max-width: 959px) {
            padding: 12px;
          }
        `,
      },
      fableticsCares: {
        cardBody: css`
          text-align: center;
        `,
        cardTitle: css`
          ${({ theme: { typography } }) => typography.values.heading3small};
          font-family: ${({ theme: { fontStacks } }) =>
            fontStacks.condensedTradeGothicFamily};
          font-weight: 800;
          line-height: ${23 / 24};

          ${mobile`
            font-size: 22px;
            line-height: ${23 / 22};
          `}
          text-transform: uppercase;
        `,
      },
      giftGuide: {
        card: css`
          background-color: ${({ theme: { colors } }) => colors.palette.white};

          grid-area: ${({ index }) => `card_${index + 1}`};
          min-width: 332px;
        `,
        cardBody: css`
          min-height: 150px;
          text-align: center;
          padding: 20px 0;
          min-height: 0;
        `,
        cardSubtitle: css`
          ${({ theme: { typography } }) => typography.values.heading4small};
          font-family: ${({ theme: { fontStacks } }) =>
            fontStacks.vipHomepageFamily};
          font-style: normal;
          font-weight: 500;
          text-transform: capitalize;

          color: ${({ theme: { colors } }) => colors.focusText};
          padding: 0 32px;
        `,
        cardTitle: css`
          ${({ theme: { typography } }) => typography.values.heading2small};
          line-height: ${42 / 28};
          font-weight: 800;
          font-family: ${({ theme: { fontStacks } }) =>
            fontStacks.condensedTradeGothicFamily};
          text-transform: uppercase;

          color: ${({ theme: { colors } }) => colors.focusText};
          padding: 0 32px;
        `,
        cardImage: css`
          max-width: 100%;
        `,
      },
    },
  },
  activeLineItemMiniCart: css`
    &.active {
      background: ${({ theme: { colors } }) => colors.palette.mamba25};
    }
  `,
  productRatingWrapper: css`
    margin-bottom: 8px;
  `,
  preOrderCallout: css`
    ${({ theme }) => theme.typography.values.heading8}
    padding: 2px 8px;
    margin-bottom: 10px;
    border-radius: 8px;
    font-weight: 600;
    background: ${({ theme: { colors } }) => colors.backgroundEmphasizedLight};
    width: fit-content;
    color: ${({ theme: { colors } }) => colors.textEmphasized};
    ${mobile`
      margin-top: 4px;
    `}
    text-transform: none;
  `,
  productDetailMarketingCallout: {
    calloutWrapper: css`
      margin-bottom: 10px;
    `,
    productCallout: css`
      font-size: 12px;
      font-weight: 700;
      letter-spacing: ${-0.43 / 12}em;
      line-height: 1.67;

      padding: 0 8px;
      border-radius: 4px;
    `,
  },
  floatingFilterButton: css`
    background-color: ${({ theme }) => theme.colors.palette.black};
  `,
  tabsNode: {
    activeTabLabel: css`
      text-decoration: underline;
      text-underline-offset: 2px;
    `,
    bannerAriaHiddenWrapper: css`
      ${mobile`
        margin: 0px;
      `}
    `,
    bannerCopy: css`
      margin: 0px;
      padding: 0px;
    `,
    buttonText: css`
      font-weight: 700;
      font-size: 16px;
      text-transform: uppercase;
      white-space: nowrap;
    `,
    carousel: css``,
    countdown: css`
      ${mobile`
        padding-top: 10px;
      `}
    `,
    countdownDigits: css``,
    countdownWrapper: css`
      background: ${({ theme }) => theme.colors.palette.lightestSoftSilk};
      height: 44px;
    `,
    image: css`
      margin-bottom: 12px;
    `,
    scrolledTabsWrapper: css`
      border-radius: 0px;

      ${desktop`
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 40px;

        padding-top: ${({ theme }) => theme.sizes.sm}px;
        padding-right: 0px;
        padding-bottom: ${({ theme }) => theme.sizes.sm}px;
        padding-left: 64px;
      `}
    `,
    scrolledTabsSelectorWrapper: css`
      border-radius: 0px;

      ${mobile`
        background: ${({ theme }) => theme.colors.white};
      `}
    `,
    scrolledTabsSelectors: css`
      border-radius: ${({ theme }) => theme.sizes.xxxs}px;
      margin-right: 16px;
    `,
    styledTabs: css`
      ${mobile`
        padding-bottom: 10px;
      `}
    `,
    postRegTabs: {
      floating: {
        navigation: {},
        countdown: {},
      },
    },
  },
  sizeFabricGuideModal: {
    fitGuideLink: css`
      & > span {
        color: ${({ theme }) => theme.colors.fitGuideLink};

        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.025em;
        text-decoration: underline;
      }
    `,
  },
  fitGuideHeader: css`
    ${({ theme }) => theme.typography.values.heading1small};
  `,
  fitGuideContentHeader: css`
    ${({ theme }) => theme.typography.values.heading1small};
    margin-top: 20px;
    margin-bottom: 18px;
    ${mobile`
      ${({ theme }) => theme.typography.values.heading6};
      margin-top: 40px;
      margin-bottom: 16px;
    `}
  `,
  fitGuideContentSubHeader: css`
    ${({ theme }) => theme.typography.values.heading4small};
  `,
  fitGuideTabButton: css`
    margin: 0 12px;
    padding: 5px 0;
    display: flex;
    text-transform: uppercase;
    border-bottom: 3px solid transparent;
    ${({ theme }) => theme.typography.values.paragraph1};
    &.active {
      border-bottom-color: ${({ theme }) => theme.colors.textDefault};
      transition: border-bottom-color 500ms ease-in-out;
    }
  `,
  fitGuideDropdownMenuListItem: css`
    &.active {
      color: ${({ theme }) => theme.colors.unfocusedAction};
    }
  `,
  sizePreferencesDropdownList: css`
    &&& {
      max-height: 360px;
      overflow-y: scroll;
      z-index: 999;
      border-radius: 3px;
      padding-top: 0;
      top: 46px;
    }
    color: ${({ theme: { colors } }) => colors.focusText};
  `,
  sizePreferencesDropdownListItem: css``,
  pdpScrollOffset: css`
    ${mobile`
      padding-top: 63px;
   `}
  `,
  pauseBillingStyling: {
    wrapperBorder: css`
      border: 3px solid
        ${({ theme: { colors } }) => colors.palette.eerieBlack25};
    `,
    iconTextColor: css`
      color: #008000;
    `,
    pauseBillingButton: css`
      ${desktop`
      margin: 0px 10px 0 0;
      `}
      ${mobile`margin: 25px auto 0;`}
      background: ${({ theme }) => theme.colors.palette.white};
      padding: 15px 15px;
      height: auto;
      width: 75%;
      border: 3px solid ${({ theme }) => theme.colors.palette.black};
      &:active {
        background: ${({ theme }) => theme.colors.palette.white};
        border: 3px solid ${({ theme }) => theme.colors.palette.black};
      }
      &:hover {
        background: ${({ theme }) => theme.colors.palette.white};
        border: 3px solid ${({ theme }) => theme.colors.palette.black};
      }
      > span {
        color: ${({ theme }) => theme.colors.palette.black};
      }
    `,
  },
  storeLocator: {
    announcement: css`
      color: ${({ theme: { colors } }) => colors.palette.jewelRed70};
    `,
    address: css``,
    phone: css``,
    locatorTop: css`
      background: ${({ theme: { colors } }) => colors.palette.mamba25};
    `,
    storeName: css``,
    locatorGridMobile: css`
      background: ${({ theme: { colors } }) => colors.palette.mamba25};
    `,
    locatorTopLeadMobile: css``,
    locatorButtonMobile: css`
      min-width: 240px;
    `,
  },
  VariantVipContact: {
    contactButtonStyle: css`
      padding: 2px 10px;
      border: 3px solid #000;
      border-radius: 12px;
      margin-bottom: 10px;
      width: 70%;
    `,
    ContactLightTextAnytime: {
      fontSize: css``,
    },
  },
  hypeDriver: {
    formStyle: css`
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: 16px;
      width: 500px;
      margin: 0 auto;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      color: ${({ theme }) => theme.colors.textDefault};
      ${mobile`
        width: 100%;
     `}
    `,
    textInputStyle: css`
      height: 48px;
      margin-bottom: 18px;
      fieldset {
        height: 50px;
        border-radius: 16px;
        box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.border};
        border-bottom: none;
      }
      ${mobile`
        font-size: 16px;
      `}
      [disabled] {
        color: ${({ theme }) => theme.colors.unfocusedLabel};
      }
    `,
    buttonStyle: css`
      margin-top: ${({ theme }) => theme.sizes.lg}px;
      width: 100%;
      border-radius: 16px;
    `,
  },
  loyaltyCountDownStyle: {
    markup: css`
      background: ${({ theme }) => theme.colors.palette.mamba25};
      height: 40px;
    `,
    wrapperStyling: css`
      height: 86px;
      border: 1px solid ${({ theme }) => theme.colors.unfocusedSublabel};
    `,
    numericWrapperStyling: css`
      line-height: 35px;
    `,
    abbreviationStyling: css`
      line-height: 20px;
    `,
  },
  cashRewardGrid: {
    assetTextSize: css`
      font-size: 54px;
      line-height: 90px;
      padding: 15px;
    `,
    buttonStyling: css`
      padding: 14px 5px;
      border-radius: 14px;
    `,
    buttonActive: css`
      background: ${({ theme }) => theme.colors.backgroundDark};
      color: ${({ theme }) => theme.colors.backgroundLight};
      opacity: 1;
      &:hover {
        background: ${({ theme }) => theme.colors.backgroundDark};
        > span {
          color: ${({ theme }) => theme.colors.backgroundLight};
        }
      }
    `,
    buttonDisable: css`
      background: ${({ theme }) => theme.colors.backgroundDark};
      > span {
        color: ${({ theme }) => theme.colors.backgroundLight};
      }
    `,
    lockIconStyling: css`
      top: 30%;
    `,
    customLockIcon: css`
      ${mobile`
        top: 60%;
      `}
    `,
    modalBackground: css`
      background: ${({ theme: { colors } }) => colors.palette.white};
      color: ${({ theme: { colors } }) => colors.palette.trueBlack};
    `,
    modalBorder: css`
      border: 4px solid ${({ theme }) => theme.colors.palette.white};
      border-radius: 8px;
      background: ${({ theme: { colors } }) => colors.palette.white};
    `,
    modalHeaderFontSize: css`
      font-size: 60px;
      ${mobile`
        font-size: 42px;
        margin: 15px auto 10px;
      `}
    `,
    modalSubHeaderStyling: css`
      margin: 15px auto;
    `,
    modalMessage: css`
      color: ${({ theme: { colors } }) => colors.palette.trueBlack};
      font-family: ${({ theme: { fontStacks } }) =>
        fontStacks.standardGtPressuraFamily};
      ${mobile`
        padding: 0 15px;
      `}
    `,
    modalRedeemButton: css`
      cursor: pointer;
      font-size: 20px;
      ${({ theme: { colors } }) => `
        background-color: ${colors.loyaltyActivePrimaryButton};
      `}

      ${({ isDisabled, hasPromo }) =>
        (isDisabled || hasPromo) &&
        css`
          ${({ theme: { colors } }) => `
            background-color: ${colors.loyaltyDisablePrimaryButton};
          `}
          cursor: not-allowed;
        `}

       ${({ isRedeemed }) =>
        isRedeemed &&
        css`
          font-size: 15px;
        `}

      &:hover {
        ${({ theme: { colors } }) => `
          background-color: ${colors.palette.mamba125};
        `}
      }

      &:focus {
        ${({ theme: { colors } }) => `
          background-color: ${colors.palette.mamba125};
        `}
      }
      color: ${({ theme }) => theme.colors.white};
      width: 100%;
      margin: 21px auto;
      text-transform: uppercase;

      font-weight: 700;
      text-align: center;
      padding: 14px;
      border-radius: 16px;
      cursor: pointer;
    `,
  },
  miniCart: {
    itemCount: css`
      color: ${({ theme: { colors } }) => colors.textFadedAlternate};
      font-weight: 400;
    `,
    itemQuality: {
      label: css`
        font-weight: 400;
      `,
      name: css`
        font-weight: 700;
      `,
    },
    scarcityNotices: {
      header: css`
        background: ${({ theme }) =>
          theme.colors.backgroundEmphasizedLightAlternate};
      `,
      lineItem: css`
        color: ${({ theme: { colors } }) => colors.promoText};
      `,
    },
    embroidery: {
      label: css`
        font-weight: 400;
      `,
      name: css`
        font-weight: 700;
      `,
    },
    timer: {
      wrapper: css`
        background: ${({ theme: { colors } }) =>
          colors.backgroundCalloutAlternate};
      `,
      text: css`
        color: ${({ theme }) => theme.colors.backgroundLight};
      `,
      border: css`
        border: 3px solid ${({ theme }) => theme.colors.backgroundLight};
      `,
    },
    promo: css`
      font-weight: 700;
    `,
    button: css``,
    productLabel: css``,
    headerTitle: css``,
    emptyMessage: css``,
  },
  memberCreditCallout: {
    memberCreditCalloutWrapperMinicart: css`
      margin-top: 10px;

      ${mobile`
        margin-top: 6px;
      `}
    `,
    memberCreditCalloutCopy: css`
      font-size: 12px;
      font-weight: 600;
      line-height: ${20 / 12};

      color: ${({ theme }) => theme.colors.palette.trueBlack};
      background-color: ${({ theme }) => theme.colors.palette.mamba25};
      border-radius: 4px;
      padding: 0px 8px;

      ${mobile`
        padding: 2px 8px;
      `}
    `,
  },
  byo: {
    pdpCtaTooltipTextWrapper: css`
      font-weight: 600;

      margin-top: 12px;
    `,
    minicartPromptCopy: css`
      font-size: 14px;
      font-weight: 700;
      line-height: ${24 / 17};
    `,
  },
  search: {
    featuredProductListItem: css`
      ${({ isHighlighted, theme }) =>
        isHighlighted && {
          outline: `2px solid ${transparentize(
            0.25,
            theme.colors.backgroundDark
          )}`,
        }};
    `,
    text: css`
      font-weight: 400;
    `,
  },
  promoMessage: {
    /**
     *  This overrides an !important coming from the CMS Asset tool for prioritized promos.
     *  The defined Asset for the prioritized promo, under use of featureNames.PRIORITIZED_PROMOS,
     *  has an HTML input text editor for the promo label entry. In some cases, the user could apply
     *  a paragraph (p) HTML element to the label entry, which comes with default styles applied
     *  per the HTML default styles spec, and an !important applied to that default style. The
     *  !important below overrides the CMS driven HTML input explained above.
     */
    overrideMarkupStylesFromCms: css`
      & > p {
        display: inline-block;
        margin-bottom: 0px !important;
      }
    `,
  },
  builderFooter: {
    footerLink: {
      bold: css`
        font-weight: 700;
      `,
      label: css`
        font-size: 14px;
        font-weight: 400;
        line-height: 1.3;

        ${mobile`
          font-size: 12px;
          font-weight: 600;
          line-height: 1.5;
          text-transform: uppercase;
        `}
      `,
      link: css`
        padding: 4px 0px;
        display: inline-block;
        color: ${({ theme }) => theme.colors.palette.lightBlack};

        &:hover span {
          text-decoration: underline;
        }

        ${mobile`
          padding: 10px 0px 10px 30px;
        `}
      `,
      oneTrust: css`
        color: ${({ theme }) => theme.colors.palette.lightBlack};
        padding: 4px 0;

        ${mobile`
          font-size: 12px;
          font-weight: 600;
          line-height: 1.5;
          text-transform: uppercase;

          padding: 10px 0px 10px 30px;
        `}

        &:hover {
          text-decoration: underline;
        }
      `,
    },
  },
  builderHeader: {
    customColors: {
      sale: css`
        color: ${({ theme }) => theme.colors.saleText};
      `,
      memberOffer: css`
        color: ${({ theme }) => theme.colors.memberOfferText};
      `,
    },
    navTabsListWithFlyoutMenu: {
      wrapper: css`
        padding-left: 12px;
      `,
      tabLabel: {
        base: css`
          font-size: 16px;
          font-weight: 500;
          text-transform: uppercase;

          &::after {
            content: '';
            position: absolute;
            width: 0%;
            margin: 0 auto;
            height: 3px;
            bottom: 0;
            left: 50%;
            transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border-radius: 10px;
          }
        `,
        focus: css`
          font-weight: 900;
        `,
        customBackgroundColors: {
          sale: css`
            background-color: ${({ theme }) => theme.colors.saleText};
          `,
          memberOffer: css`
            background-color: ${({ theme }) => theme.colors.memberOfferText};
          `,
        },
      },
      tabLink: css`
        padding: 0 16px;
      `,
      content: css`
        padding: 16px 24px;
      `,
    },
    metaNav: css`
      background-color: ${({ theme }) => theme.colors.palette.lightestSoftSilk};
    `,
    metaNavItem: {
      hover: css`
        background-color: ${({ theme }) =>
          theme.colors.palette.lighterSoftSilk};
      `,
    },
    countryMenuItem: css`
      border-top: ${({ theme }) =>
        `1px solid ${theme.colors.countryDropdownMenuBorder}`};
      border-bottom: ${({ theme }) =>
        `1px solid ${theme.colors.countryDropdownMenuBorder}`};

      &:hover {
        font-weight: 600;
        background-color: ${({ theme }) =>
          theme.colors.palette.lightestSoftSilk};
      }
    `,
    tertiaryNavItem: {
      wrapper: css`
        color: ${({ theme }) => theme.colors.palette.trueBlack};

        padding: 16px 24px;

        ${mobile`
          color: ${({ theme }) => theme.colors.palette.white};
          background-color: ${({ theme }) => theme.colors.palette.deepBrown};
        `}
      `,
      styledLabel: css``,
    },
    navLink: {
      bold: css`
        font-weight: 700;
      `,
      wrapper: css`
        &:hover {
          background-color: ${({ theme }) => theme.colors.palette.mamba25};
        }
      `,
      label: css`
        font-weight: 400;
      `,
      link: css`
        padding: 8px 10px;

        ${mobile`
          padding: 12px 46px;
        `}
      `,
      callout: {
        default: css`
          color: ${({ theme }) => theme.colors.palette.black};
          background-color: ${({ theme }) => theme.colors.palette.mamba25};
          font-size: 11px;
          font-weight: 700;

          border-radius: 6px;
          margin-left: 10px;
          padding: 4px 6px;
        `,
        customColors: {
          priority1: css`
            background-color: ${({ theme }) => theme.colors.palette.softSilk};
          `,
          priority2: css`
            color: ${({ theme }) => theme.colors.palette.white};
            background-color: ${({ theme }) =>
              theme.colors.palette.burntOrange};
          `,
        },
      },
    },
    myAccountFlyoutMenu: {
      greetingWrapper: css`
        font-weight: 600;
      `,
    },
    accountNavLink: {
      wrapper: css`
        &:hover {
          background-color: ${({ theme }) =>
            theme.colors.palette.lightestSoftSilk};
        }
      `,
      link: css`
        font-weight: 400;
        color: ${({ theme }) => theme.colors.palette.trueBlack};
      `,
    },
    fallbackHeader: {
      logoWrapper: css`
        padding: 8px 27px;
        width: fit-content;

        ${mobile`
          padding: 12px;
          margin: 0 auto;
        `}
      `,
      stickyWrapper: css``,
    },
    stickyContainer: {
      contents: css`
        border-bottom: 1px solid
          ${({ theme }) => theme.colors.palette.lightestMidnight};
      `,
    },
    signInWithModal: {
      signInButton: css`
        color: ${({ theme }) => theme.colors.palette.black};
        font-size: 12px;

        margin-left: 12px;
      `,
      actionText: css`
        font-weight: 700;
        text-decoration: underline;
      `,
    },
    flyOutMenu: {
      interactiveElement: css`
        padding: ${({ theme }) => theme.sizes.sm}px;
      `,
    },
    hamburgerMenu: {
      hamburgerButton: css`
        padding: 12px 20px;
      `,
    },
    navTabsListWithContent: {
      tab: css``,
    },
  },
  builderCategoryNav: {
    breadcrumbs: {
      breadCrumbListItem: {
        default: css``,
        active: css`
          color: ${({ theme }) => theme.colors.gridActiveBreadcrumbTextColor};
          font-weight: 600;
        `,
      },
    },
    navLink: {
      styledCategoryNavLink: {
        default: css`
          ${desktop`
            font-weight: normal;
            text-decoration: none;
          `}
        `,
        active: css`
          ${desktop`
            font-weight: 600;
            text-decoration: underline;
          `}
        `,
      },
    },
  },
  expansionPanel: {
    panelHeader: {
      primary: css`
        background-color: inherit;
        border-bottom: none;

        padding: 16px 32px 16px 16px;
      `,
      secondary: css`
        background-color: ${({ theme }) => theme.colors.palette.white};

        padding: 16px 32px 16px 32px;
      `,
      footer: css`
        ${mobile`
          font-weight: 600;
          
          padding-top: 1.25em;
          padding-bottom: 1.25em;
        `}

        svg {
          font-size: 12px;
        }
      `,
    },
    panelLabel: {
      primary: css`
        color: ${({ theme }) => theme.colors.palette.black};
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
      `,
      secondary: css`
        color: ${({ theme }) => theme.colors.palette.lightDeepBrown};
        font-size: 16px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.1em;
      `,
      footer: css`
        color: ${({ theme }) => theme.colors.palette.lightBlack};
        font-size: 14px;
        font-weight: 600;
        line-height: 1.5;
        text-transform: uppercase;
      `,
    },
    panelIcon: css`
      color: ${({ theme }) => theme.colors.palette.midnight};
    `,
    panelWrapper: {
      footer: css`
        ${mobile`
          font-size: 12px;
          
          padding: 0 ${({ theme }) => theme.space('xl')};
        `}
      `,
    },
  },
  listColumn: {
    header: css`
      font-size: 16px;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.palette.deepBrown};

      padding: 0px 10px 10px 10px;
    `,
    separator: css`
      border-top: 2px solid
        ${({ theme }) => theme.colors.palette.lightNakedRose};
    `,
    wrapper: {
      footer: css`
        padding-bottom: 0;
      `,
    },
    unorderedList: {
      footer: css`
        border-bottom: 1px solid
          ${({ theme }) => theme.colors.palette.eerieBlack75};
        span {
          font-size: 12px;
          text-transform: uppercase;
        }
      `,
    },
  },
  errorBackground: css`
    background: repeating-linear-gradient(
      45deg,
      #fce1df,
      #fce1df 10px,
      #f3baba 10px,
      #f3baba 20px
    );
  `,
  sizeSelectionExpansionPanel: {
    sizeSelectionHeader: {
      header: css`
        color: ${({ theme }) => theme.colors.palette.deepBrown};
        padding: ${({ theme }) => theme.sizes.md}px;

        ${({ open, theme }) =>
          open &&
          css`
            padding-bottom: ${open ? theme.sizes.sm : theme.sizes.md}px;
          `}
      `,
      sizeHeader: css`
        color: ${({ theme }) => theme.colors.palette.eerieBlack};
      `,
      editSizeButton: css`
        color: ${({ theme }) => theme.colors.palette.eerieBlack};
      `,
    },
    sizeSelectionContent: {
      content: css`
        padding: ${({ theme }) => theme.sizes.md}px 0px;
        padding-top: unset;

        ${desktop`
        ${({ theme }) => `
          padding: ${theme.sizes.md}px;
        `}
      `}
      `,
      sizeButton: css`
        ${({ theme: { sizes, colors }, $selected }) => `
        padding: ${sizes.sm}px;

        border-radius: ${sizes.xxs}px;
        border: 1px solid ${colors.palette.gray};
        background-color: ${({ theme }) =>
          theme.colors.palette.lightestMidnight};

        ${
          $selected
            ? `border: 3px solid ${colors.palette.deepBrown};`
            : `margin: 2px;`
        };
        :hover {
          border: 1px solid ${colors.palette.deepBrown};
        }
      `}
      `,
    },
    collapsibleWrapper: css`
      color: ${({ theme }) => theme.colors.palette.deepBrown};
      background-color: ${({ theme }) => theme.colors.palette.white};

      border: 3px solid ${({ theme }) => theme.colors.palette.gray};

      &:first-child {
        border-radius: 16px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;

        border-top: 3px solid ${({ theme }) => theme.colors.palette.gray};
        border-bottom: 1px solid ${({ theme }) => theme.colors.palette.gray};
      }

      &:nth-child(2) {
        border-bottom: 0px solid ${({ theme }) => theme.colors.palette.gray};
        border-top: 0px solid ${({ theme }) => theme.colors.palette.gray};
      }

      &:last-child {
        border-radius: 16px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;

        border-bottom: 3px solid ${({ theme }) => theme.colors.palette.gray};

        ${({ showBra }) =>
          showBra &&
          css`
            border-top: 1px solid ${({ theme }) => theme.colors.palette.gray};
          `}

        ${({ showBra }) =>
          !showBra &&
          css`
            border-top: none;
          `}
      }
    `,
  },
  iconButtonModal: {
    header: css`
      font-size: 32px;
      font-weight: 700;
    `,
    subheader: css`
      font-size: 16px;
      font-weight: 700;
    `,
    copy: css`
      font-size: 16px;
    `,
  },
  communicationPreferencesToggle: css``,
  promoPickerPopup: {
    promoPickerBottomSubHeader: css``,
    promoPickerLogoIcon: css`
      margin-inline: auto;
      margin-top: 24px;
      ${mobile`
          margin-top: 64px;
        `}
    `,
    panelTemplateSubheadingFontSize: css`
      font-size: 24px;
      ${mobile`
    font-size: 18px;
  `}
    `,
    desktopHeaderFontSize: 60,
    mobileHeaderFontSize: 50,
    desktopSubHeaderFontSize: 24,
    mobileSubHeaderFontSize: 20,
    header: css`
      line-height: ${72.5 / 78};
      font-weight: 700;

      ${mobile`
        line-height: ${72.5 / 60};
      `}
    `,
    subHeader: css`
      line-height: ${29 / 27};
      letter-spacing: -0.02em;
      font-weight: 500;

      ${mobile`
        line-height: ${29 / 24};
      `}
    `,
    signupSubmitButtonText: css``,
    signInButton: css`
      margin-bottom: 65px;
    `,
    closeButton: css`
      color: ${({ theme }) => theme.colors.textDefault};
    `,
    loginHeading: css``,
    sizingGrid: css`
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;

      & button {
        background: ${({ theme }) => theme.colors.palette.lightestMidnight};
        padding: 8px 12px;
      }

      ${desktop`
        grid-template-columns: repeat(6, 1fr);
        width: auto;
        gap: 8px;

        & button {
          padding: 16px;
        }
      `}
    `,
  },
  fmbe: {
    header: css`
      line-height: ${72.5 / 78};
      font-weight: 700;

      ${mobile`
        line-height: ${72.5 / 60};
      `}
    `,
    subHeader: css`
      line-height: ${29 / 27};
      letter-spacing: -0.02em;
      font-weight: 500;

      ${mobile`
        line-height: ${29 / 24};
      `}
    `,
  },
  errorPage: {
    errorBody: css``,
  },
  ctaNode: {
    linkText: css`
      color: ${({ theme }) => theme.colors.palette.eerieBlack75};
      font-weight: 700;
    `,
  },
  navigation: {
    styledLink: css``,
  },
  searchCio: {
    desktopOverlay: {
      logoWrapper: css`
        width: 102px;
      `,
    },
  },
  speedySignup: {
    goBackToSignUpWrapperAdditionalStyle: css``,
  },
  tldNavLink: {
    wrapper: css``,
    link: css`
      display: flex;
    `,
  },
  accordionUnit: {
    itemHeader: css`
      ${mobile`
        padding: 0 10px;
      `}
    `,
    titleHeader: css`
      font-size: 18px;
      font-weight: 600;
    `,
  },
  pdpMainContent: {
    productName: css`
      font-size: 22px;
      font-weight: 500;
      letter-spacing: ${-0.6 / 24}em;

      ${mobile`
        font-size: 20px;
      `}
    `,
  },
  productReview: {
    countLabelWrapper: css`
      text-decoration: underline;
    `,
  },
  productDetailPrice: {
    priceContent: css`
      font-size: 16px;
      font-weight: 500;
    `,
    priceStyle: css`
      font-weight: 600;
    `,
  },
  vipOptInModal: {
    contentWrapperStyles: css``,
    modalStyles: css``,
  },
  membershipContactBox: {
    contactAvailability: css``,
    contactButton: css`
      font-weight: 600;
      font-size: 16px;
    `,
    styledButton: {
      copy: css``,
    },
  },
  checkout: {
    ...checkoutThemeTokens,
  },
};
